import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const $PriceView = (tag, _1) => ({tag, _1});
const Constant = value0 => $PriceView("Constant", value0);
const Range = value0 => $PriceView("Range", value0);
const semigroupPriceView = {
  append: v => v1 => {
    if (v1.tag === "Constant") {
      if (v.tag === "Constant") { return $PriceView("Constant", {value: v._1.value + v1._1.value | 0}); }
      if (v.tag === "Range") { return $PriceView("Range", {from: v._1.from + v1._1.value | 0, to: v._1.to + v1._1.value | 0}); }
      $runtime.fail();
    }
    if (v1.tag === "Range") {
      if (v.tag === "Range") { return $PriceView("Range", {from: v._1.from + v1._1.from | 0, to: v._1.to + v1._1.to | 0}); }
      if (v.tag === "Constant") { return $PriceView("Range", {from: v._1.value + v1._1.from | 0, to: v._1.value + v1._1.to | 0}); }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const priceView = price => parameterValues => {
  const v = Restaumatic$dMenu$dV2$dParametric.evaluateParametric(price)(parameterValues);
  if (v.tag === "Left") {
    if (v._1.tag === "MissingValue") { return Data$dMaybe.Nothing; }
    if (v._1.tag === "MissingParameters") {
      const prices = Data$dMap$dInternal.values(v._1._2.values);
      const $0 = Data$dFoldable.minimumBy(Data$dList$dTypes.foldableList)(Data$dOrd.ordInt.compare)(prices);
      const $1 = Data$dFoldable.maximumBy(Data$dList$dTypes.foldableList)(Data$dOrd.ordInt.compare)(prices);
      if ($1.tag === "Just") {
        if ($0.tag === "Just") {
          if ($0._1 === $1._1) { return Data$dMaybe.$Maybe("Just", $PriceView("Constant", {value: $0._1})); }
          return Data$dMaybe.$Maybe("Just", $PriceView("Range", {from: $0._1, to: $1._1}));
        }
        return Data$dMaybe.Nothing;
      }
      return Data$dMaybe.Nothing;
    }
    $runtime.fail();
  }
  if (v.tag === "Right") { return Data$dMaybe.$Maybe("Just", $PriceView("Constant", {value: v._1})); }
  $runtime.fail();
};
const productPriceView = _catalogue => product => parameterValues => {
  if (Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(product.variants)(parameterValues)) { return priceView(product.price)(parameterValues); }
  return Data$dMaybe.Nothing;
};
const monoidPriceView = {mempty: /* #__PURE__ */ $PriceView("Constant", {value: 0}), Semigroup0: () => semigroupPriceView};
const mergePriceView = v => v1 => {
  if (v1.tag === "Constant") {
    if (v.tag === "Constant") {
      if (v._1.value === v1._1.value) { return $PriceView("Constant", {value: v._1.value}); }
      return $PriceView(
        "Range",
        {
          from: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.value)(v1._1.value);
            if (v$1.tag === "LT") { return v._1.value; }
            if (v$1.tag === "EQ") { return v._1.value; }
            if (v$1.tag === "GT") { return v1._1.value; }
            $runtime.fail();
          })(),
          to: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.value)(v1._1.value);
            if (v$1.tag === "LT") { return v1._1.value; }
            if (v$1.tag === "EQ") { return v._1.value; }
            if (v$1.tag === "GT") { return v._1.value; }
            $runtime.fail();
          })()
        }
      );
    }
    if (v.tag === "Range") {
      return $PriceView(
        "Range",
        {
          from: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.from)(v1._1.value);
            if (v$1.tag === "LT") { return v._1.from; }
            if (v$1.tag === "EQ") { return v._1.from; }
            if (v$1.tag === "GT") { return v1._1.value; }
            $runtime.fail();
          })(),
          to: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.to)(v1._1.value);
            if (v$1.tag === "LT") { return v1._1.value; }
            if (v$1.tag === "EQ") { return v._1.to; }
            if (v$1.tag === "GT") { return v._1.to; }
            $runtime.fail();
          })()
        }
      );
    }
    $runtime.fail();
  }
  if (v1.tag === "Range") {
    if (v.tag === "Range") {
      return $PriceView(
        "Range",
        {
          from: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.from)(v1._1.from);
            if (v$1.tag === "LT") { return v._1.from; }
            if (v$1.tag === "EQ") { return v._1.from; }
            if (v$1.tag === "GT") { return v1._1.from; }
            $runtime.fail();
          })(),
          to: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.to)(v1._1.to);
            if (v$1.tag === "LT") { return v1._1.to; }
            if (v$1.tag === "EQ") { return v._1.to; }
            if (v$1.tag === "GT") { return v._1.to; }
            $runtime.fail();
          })()
        }
      );
    }
    if (v.tag === "Constant") {
      return $PriceView(
        "Range",
        {
          from: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.value)(v1._1.from);
            if (v$1.tag === "LT") { return v._1.value; }
            if (v$1.tag === "EQ") { return v._1.value; }
            if (v$1.tag === "GT") { return v1._1.from; }
            $runtime.fail();
          })(),
          to: (() => {
            const v$1 = Data$dOrd.ordInt.compare(v._1.value)(v1._1.to);
            if (v$1.tag === "LT") { return v1._1.to; }
            if (v$1.tag === "EQ") { return v._1.value; }
            if (v$1.tag === "GT") { return v._1.value; }
            $runtime.fail();
          })()
        }
      );
    }
    $runtime.fail();
  }
  $runtime.fail();
};
const genericPriceView = {
  to: x => {
    if (x.tag === "Inl") { return $PriceView("Constant", x._1); }
    if (x.tag === "Inr") { return $PriceView("Range", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Constant") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Range") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showPriceView = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["value", Data$dMoney$dRounded.toString(v.value)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Constant"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["from", Data$dMoney$dRounded.toString(v.from)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "to",
            Data$dMoney$dRounded.toString(v.to)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Range"});
    return x => {
      if (x.tag === "Constant") { return $0["genericShow'"](x._1); }
      if (x.tag === "Range") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const display = v => {
  if (v.tag === "Constant") { return Data$dMoney$dRounded.toString(v._1.value); }
  if (v.tag === "Range") { return Data$dMoney$dRounded.toString(v._1.from) + " – " + Data$dMoney$dRounded.toString(v._1.to); }
  $runtime.fail();
};
const comboPriceView = catalogue => combo => paramValues => Data$dFoldable.foldableArray.foldMap(monoidPriceView)(x => x)(Data$dFunctor.arrayMap(element => {
  const $0 = Data$dFoldable.foldrArray(v => v1 => {
    if (v.tag === "Just") {
      if (v1.tag === "Just") { return Data$dMaybe.$Maybe("Just", mergePriceView(v._1)(v1._1)); }
      if (v1.tag === "Nothing") { return Data$dMaybe.$Maybe("Just", v._1); }
      $runtime.fail();
    }
    if (v.tag === "Nothing") {
      if (v1.tag === "Just") { return Data$dMaybe.$Maybe("Just", v1._1); }
      if (v1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    }
    $runtime.fail();
  })(Data$dMaybe.Nothing)(Data$dFunctor.arrayMap(choice => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(choice.product)(Data$dRecord.unsafeGet("products")(catalogue));
    if ($0.tag === "Just") {
      return priceView((() => {
        if (choice.priceOverride.tag === "Nothing") { return $0._1.price; }
        if (choice.priceOverride.tag === "Just") { return choice.priceOverride._1; }
        $runtime.fail();
      })())(Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFunction.const)(paramValues)(Restaumatic$dMenu$dV2$dParametric.fromCustomParameterValues(choice.customParameterValues)));
    }
    if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })(Data$dFunctor.arrayMap(Data$dTuple.snd)(element.choices._2)));
  if ($0.tag === "Nothing") { return monoidPriceView.mempty; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
})(Data$dFunctor.arrayMap(Data$dTuple.snd)(combo.elements._2)));
export {$PriceView, Constant, Range, comboPriceView, display, genericPriceView, mergePriceView, monoidPriceView, priceView, productPriceView, semigroupPriceView, showPriceView};
